import { render, staticRenderFns } from "./ConsPrem.vue?vue&type=template&id=7ecb176c&"
import script from "./ConsPrem.vue?vue&type=script&lang=js&"
export * from "./ConsPrem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports